import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@core-app/layout/layout.module';
import { OnePageModule } from '@core-app/one-page/one-page.module';
import { MockDataInterceptor } from '@core-app/services/mocking/mock-data.interceptor';
import { appReducer, CoreModule, metaReducers, SettingsService } from '@gallaghercp/core-frontend';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_CONFIG as LOCAL_APP_CONFIG } from './app.config';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CoreModule,
        LayoutModule,
        OnePageModule,
        StoreModule.forRoot({ app: appReducer }, { metaReducers }),
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = initialiseAppConfig(inject(SettingsService));
            return initializerFn();
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MockDataInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}

export function initialiseAppConfig(settings: SettingsService): () => Promise<any> {
    return () => settings.init(LOCAL_APP_CONFIG);
}
